import { Divider, Stack } from '@mui/material';

import ProviderActivityView from './ProviderActivityView/ProviderActivityView';
import ProviderComparisonView from './ProviderComparisonView/ProviderComparisonView';

const AdminAnalyticsView = () => (
    <Stack spacing={3} divider={<Divider flexItem />}>
        <ProviderActivityView />
        <ProviderComparisonView />
    </Stack>
);

export default AdminAnalyticsView;
